import RadioButton from '@gef-ui/components/atoms/RadioButton';
import RadioButtonGroup from '@gef-ui/components/molecules/RadioButtonGroup';
import chainHandlers from "@gef-ui/utils/chainHandlers";
import map from "ramda/es/map";
import React from 'react';
import { radioColor, validationColor } from '../../../../constants';
const defaultCreateOptions = ({ options, disabled, valid, value })=>map((o)=>/*#__PURE__*/ React.createElement(RadioButton, {
            className: value === o.code ? radioColor(valid) : undefined,
            disabled: disabled || o.disabled,
            value: o.code,
            key: o.code,
            label: o.name
        }), options);
export default (({ codelistName, optionsFilter, handleFocusFalse, handleFocusTrue, asyncValidationInProgress, handleChange, displayValue, viewParser, errMeta, formName, errMessage, handleUpdate, handleAsyncValidate, value, handleValidate, valid, onChange, options, disabled, createOptions = defaultCreateOptions, ...other })=>/*#__PURE__*/ React.createElement(RadioButtonGroup, {
        validationText: errMessage,
        validationClassName: validationColor(valid),
        value: value ?? '',
        onChange: chainHandlers([
            handleUpdate,
            handleAsyncValidate,
            handleValidate,
            onChange
        ]),
        ...other
    }, createOptions({
        options,
        valid,
        value,
        disabled
    })));
